export const subscribeUnlinkMobile = {
  data: () => ({
    canSubscribe: false
  }),
  computed: {
    isSocketAuth() {
      return this.$store.getters.IS_SOCKET_AUTH
    }
  },
  watch: {
    canSubscribe() {
      if (this.canSubscribe && this.isSocketAuth) {
        this.subscribe()
      } else if (!this.canSubscribe) {
        this.unsubscribe()
      }
    }
  },
  created() {
    if (this.canSubscribe && this.isSocketAuth) {
      this.subscribe()
    }
  },
  beforeDestroy() {
    this.unsubscribe()
  },
  methods: {
    subscribe() {
      this.sockets.subscribe('api/unlink-mobile created', () => {
        this.setCourseBindingInfo()
      })
    },
    unsubscribe() {
      this.sockets.unsubscribe('api/link-mobile created')
    }
  }
}
